import React, { useState } from 'react';

const TimeInput = ({ value, onChange, disabled }) => {
  const [isFocused, setIsFocused] = useState(false);
  
  const handleChange = (e) => {
    let input = e.target.value.replace(/[^\d:]/g, '');
    
    if (input.length === 2 && !input.includes(':')) {
      input += ':';
    }
    
    if (input.length <= 5) {
      onChange(input);
    }
  };
  
  const handleBlur = (e) => {
    setIsFocused(false);
    const timeValue = e.target.value;
    
    if (timeValue.includes(':')) {
      let [hours, minutes] = timeValue.split(':');
      
      hours = hours.padStart(2, '0');
      minutes = (minutes || '00').padStart(2, '0');
      
      const isValid = (
        (Number(hours) === 24 && Number(minutes) === 0) ||
        (Number(hours) >= 0 && Number(hours) < 24 && Number(minutes) >= 0 && Number(minutes) < 60)
      );
      
      if (isValid) {
        onChange(`${hours}:${minutes}`);
      } else {
        onChange('');
      }
    }
  };
  
  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleKeyPress = (e) => {
    const valid = /[\d:]/.test(e.key);
    if (!valid) {
      e.preventDefault();
    }
  };
  
  return (
    <input
      type="text"
      value={value}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyPress={handleKeyPress}
      placeholder="HH:mm"
      maxLength={5}
      disabled={disabled}
      className={`
        px-0.5 py-2 border rounded w-14
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500
        disabled:bg-gray-100 disabled:cursor-not-allowed
        ${isFocused ? 'border-blue-500' : 'border-gray-300'}
      `}
    />
  );
};

export default TimeInput;